import { useGetDefaultFullControlQuery } from '@/store/settingsApi';
import { useImpersonation } from './useImpersonation';
import { useAuthIsLoaded } from './useAuthIsLoaded';

export function useCanAddAccounts(): boolean {
  const authLoaded = useAuthIsLoaded();
  const { isImpersonating, isImpersonatedByAdministrator } = useImpersonation();
  const { data, isError, isSuccess } = useGetDefaultFullControlQuery(
    undefined,
    {
      skip: !isImpersonating || !authLoaded,
    },
  );

  if (!isImpersonating || isImpersonatedByAdministrator) {
    return true;
  }

  if (isError || !isSuccess) {
    return false;
  }

  return data.ShowAwayAccountsByDefault;
}
